import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

/** 404 page for unmatched routes. */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <h1 className="text-2xl font-semibold">404</h1>
      <p className="text-sm text-muted-foreground">{t("common.notFound")}</p>
      <Button asChild variant="outline">
        <Link to="/">{t("common.back")}</Link>
      </Button>
    </div>
  );
}
